
$(document).ready(function () {
    let span_sku = $('.product-sku span').text();
     get_date(span_sku);
  

    $("#tempsku").on('DOMSubtreeModified', function () {
        let sku = $("#tempsku").text();
        if (sku != '') {
            get_date(sku);

        }

    });

function get_date(sku){
   $.ajax({
            type: "post",
            url: "https://dddemo.net/php/adil/furnigo_app/public/api/frontend/deliverydate",
            data: {"sku":sku},
            dataType: "json",
            success: function (response) {
                console.log(response);
            $('.delivery-date').html('<strong>DeliveryDate<\/strong> <span data-product-sku>'+response+' ');

            }
        });
}

});
